import { TagColors } from '@navi/web-ui/lib/primitives/Tag/types';
import { AlertTypesProps, AllCasesPageRequest } from './CasesInterfaces';
import CallCoverage from '../../TelePerformanceDashboard/DashBoardBody/TotalCallData/CallCoverage';

export const CASE_TABLE = 'casesTable';
export const CSA_TABLE_ROW_HEIGHT = 80;
export const DEFAULT_DATE = '01 Jan, 1970 | 05:30 am';
export const DEFAULT_COLOR = 'var(--navi-color-green-bg)';

export const MAX_WIDTH_SELECTED_FILTERS_DISPLAY_SEPERATE_LINE = 1060;

export const FEEDBACK_TYPES_OPTIONS = [
  { value: 'NOT_CONTACTED', label: 'Not Contacted' },
  { value: 'PROMISE_TO_PAY', label: 'Promise to Pay' },
  { value: 'BROKEN_PROMISE', label: 'Broken Promise' },
  { value: 'REQUESTED_CALLBACK', label: 'Requested Callback' },
  { value: 'DISPUTE', label: 'Dispute' },
  { value: 'CUSTOMER_EXPIRED', label: 'Customer Expired' },
  { value: 'RINGING_NO_RESPONSE', label: 'Ringing No Response' },
  { value: 'REFUSED_TO_PAY', label: 'Refused to Pay' },
  { value: 'CALL_DISCONNECTED_RPC', label: 'Call Disconnected RPC' },
  { value: 'CALL_DISCONNECTED_NON_RPC', label: 'Call Disconnected Non RPC' },
  { value: 'MESSAGE_LEFT', label: 'Message Left' },
  { value: 'SWITCHED_OFF', label: 'Switched Off' },
  { value: 'INVALID_NUMBER', label: 'Invalid Number' },
  { value: 'BUSY', label: 'Busy' },
  { value: 'WILLING_TO_PAY', label: 'Willing to pay' },
  { value: 'OTHERS', label: 'Others' }
];

export const POS_OPTIONS = [
  { value: '0-10000', label: '0 - 10,000' },
  { value: '10001-50000', label: '10,001 - 50,000' },
  { value: '50001-100000', label: '50,001 - 1,00,000' },
  { value: `100000-${Number.MAX_VALUE}`, label: '1,00,000+' }
];

export const DPD_BUCKETS_OPTIONS = [
  { value: '1-15', label: 'DPD 1-15' },
  { value: '16-30', label: 'DPD 16-30' },
  { value: '31-60', label: 'DPD 31-60' },
  { value: '61-90', label: 'DPD 61-90' },
  { value: '91-120', label: 'DPD 91-120' },
  { value: '120-999', label: 'DPD 120 and above' }
];

export const CUSTOMER_PROFILE_OPTIONS = [
  {
    label: 'Red',
    value: 'HIGH_RISK',
    id: 'HIGH_RISK'
  },
  {
    label: 'Orange',
    value: 'MEDIUM_RISK',
    id: 'MEDIUM_RISK'
  },
  {
    label: 'Green',
    value: 'LOW_RISK',
    id: 'LOW_RISK'
  }
];

export const DATE_OF_ALLOCATION = [
  { id: 'today', value: 'today', label: 'Today' },
  { id: 'last_one_day', value: 'last_one_day', label: 'Last 1 day' },
  { id: 'last_seven_days', value: 'last_seven_days', label: 'Last 7 days' },
  { id: 'last_15_days', value: 'last_15_days', label: 'Last 15 days' },
  { id: 'select_date_range', value: 'select_date_range', label: 'Select date range' }
];

export const PAYMENT_STATUS_OPTIONS = [
  { value: 'PAID', label: 'Paid' },
  { value: 'UNPAID', label: 'Unpaid' },
  { value: 'PARTIALLY_PAID', label: 'Partially Paid' }
];

export const CaseFilter = {
  paymentStatus: 'paymentStatus',
  interactionStatuses: 'interactionStatuses',
  dpdDuringAllocationFilters: 'dpdDuringAllocationFilters',
  assignedAtFilters: 'assignedAtFilters',
  states: 'states',
  riskSegments: 'riskSegments',
  agentTypes: 'agentTypes',
  ptpStatus: 'ptpStatus',
  callBackToday: 'callBackToday',
  callCoverage: 'callCoverage',
  teleInteractionStatuses: 'teleInteractionStatuses',
  fieldInteractionStatuses: 'fieldInteractionStatuses'
};

export const FilterKeyLabelMap = {
  [CaseFilter.interactionStatuses]: 'Feedback',
  [CaseFilter.paymentStatus]: 'Payment status',
  [CaseFilter.dpdDuringAllocationFilters]: 'DPD During Allocation',
  [CaseFilter.riskSegments]: 'Customer Profile',
  [CaseFilter.assignedAtFilters]: 'Allocation Date',
  [CaseFilter.states]: 'States',
  [CaseFilter.agentTypes]: 'Allocation Purpose',
  [CaseFilter.ptpStatus]: 'PTP Status',
  [CaseFilter.callBackToday]: 'Call back Today',
  [CaseFilter.callCoverage]: 'Call coverage',
  [CaseFilter.teleInteractionStatuses]: 'Longhorn Feedback',
  [CaseFilter.fieldInteractionStatuses]: 'Cosmos Feedback'
};

export const OPTION_WITH_CALENDAR_CTA = {
  PROMISE_TO_PAY: 'Promise to Pay',
  REQUESTED_CALLBACK: 'Requested Callback',
  FROM_ASSIGNED_AT: 'From Assigned At',
  TILL_ASSIGNED_AT: 'Till Assigned At'
};
export const defaultPageSize = 50;

export const defaultAllCasesPageRequest: AllCasesPageRequest = {
  pageSize: defaultPageSize,
  pageNo: 0,
  query: '',
  allocationStatus: 'ALLOCATED',
  sortByField: 'name',
  sortOrder: 'ASC',
  interactionStatuses: [],
  dpdBuckets: [],
  posAmountRanges: [],
  paymentStatus: []
};

export const defaultAllCasesRequestFields = {
  requestedCallbackDate: null,
  promiseToPayDate: null,
  nextPageToken: null,
  agencyCode: null
};

export const defaultAgregationRequest = {
  metricAggregationRequests: [
    {
      fieldName: 'balance',
      aggregationType: 'SUM'
    }
  ],
  bucketAggregationRequests: {
    histogramAggregation: [
      {
        fieldName: 'currentDpd',
        minimumDocCount: 1
      }
    ],
    termsAggregations: [
      {
        fieldName: 'permanentAddressState'
      }
    ]
  }
};

export const CasesQueryParams = {
  QUERY: 'query',
  PAGE_NO: 'pageNo',
  PAGE_SIZE: 'pageSize',
  SORT_BY_FIELD: 'sortByField',
  SORT_ORDER: 'sortOrder'
};

export const Tags = {
  ALERT: 'Alert'
} as { [key: string]: string };

export const AlertTypes = {
  CIBIL: {
    label: 'CIBIL',
    tagLabel: Tags.ALERT,
    color: 'orange'
  }
} as unknown as {
  [key: string]: AlertTypesProps;
};

interface CodeMap {
  color: TagColors;
  label: string;
}
export const FeedbackTypesCodeMap = {
  PAID: { color: 'yellow', label: 'Paid' },
  PROMISE_FULFILLED: { color: 'yellow', label: 'Promise fulfilled' },
  PAID_ON_VISIT: { color: 'green', label: 'Paid on Visit' },
  PROMISE_TO_PAY: { color: 'green', label: 'Promise to Pay' },
  BROKEN_PROMISE: { color: 'red', label: 'Broken Promise' },
  CALL_DISCONNECTED_RPC: { color: 'green', label: 'Call Disconnected RPC' },
  CALL_DISCONNECTED: { color: 'green', label: 'Call Disconnected' },
  CALL_DISCONNECTED_NON_RPC: { color: 'green', label: 'Call Disconnected Non RPC' },
  NOT_CONTACTED: { color: 'green', label: 'Not Contacted' },
  REFUSED_TO_PAY: { color: 'green', label: 'Refused to Pay' },
  REQUESTED_CALLBACK: { color: 'green', label: 'Requested Callback' },
  CALLBACK: { color: 'green', label: 'Callback' },
  MESSAGE_LEFT: { color: 'green', label: 'Message Left' },
  NOT_CONTACTABLE: { color: 'red', label: 'Not Contactable' },
  RINGING_NO_RESPONSE: { color: 'red', label: 'Ringing No Response' },
  SWITCHED_OFF: { color: 'red', label: 'Switched off' },
  DISPUTE: { color: 'red', label: 'Dispute' },
  BUSY: { color: 'red', label: 'Busy' },
  INVALID_NUMBER: { color: 'red', label: 'Invalid number' },
  WILLING_TO_PAY: { color: 'green', label: 'Willing to pay' },
  CUSTOMER_EXPIRED: { color: 'red', label: 'Customer Expired' },
  OTHERS: { color: 'green', label: 'Others' },
  ADDRESS_NOT_FOUND: { color: 'red', label: 'Address not found' },
  CUSTOMER_SHIFTED_FROM_ADDRESS: { color: 'red', label: 'Customer shifted' },
  DOOR_LOCKED: { color: 'red', label: 'Door locked' },
  DOES_NOT_KNOW_CUSTOMER: { color: 'red', label: `Doesn't know customer` },
  PICKED_UP_DISCONNECTED: { color: 'orange', label: 'Picked up and disconnected' },
  LANGUAGE_BARRIER: { color: 'orange', label: 'Language Issue' },
  TECHNICAL_ERROR: { color: 'orange', label: 'Technical Error' },
  ENTRY_RESTRICTED: { color: 'red', label: 'Entry restricted' },
  CUSTOMER_NEVER_LIVED_IN_ADDRESS: { color: 'red', label: 'Customer never lived in address' },
  PROMISE_TO_PAY_LATER: { color: 'green', label: 'Promise to pay later' },
  OUT_OF_NETWORK: { color: 'red', label: 'Out of network' },
  NOT_AVAILABLE: { color: 'blue', label: 'Not Available' },
  MISSED_CALL: { color: 'blue', label: 'Missed Call' },
  PAID_ON_CALL: { color: 'yellow', label: 'Paid on call' },
  PTP_FROM_FRIENDS_OR_FAMILY: { color: 'green', label: 'PTP from friends and family' },
  REQUESTED_VISIT: { color: 'green', label: 'Requested visit' },
  FRAUD: { color: 'red', label: 'Fraud' },
  ACCOUNT_UNAVAILABLE: { color: 'red', label: 'Account Unavailable' },
  PAY_LATER: { color: 'green', label: 'Pay later' }
} as { [key: string]: CodeMap };

export const CasesDetailsFeedbackTypesCodeMap = {
  Paid: { color: 'yellow', label: 'Paid' },
  'Promise Fulfilled': { color: 'yellow', label: 'Promise fulfilled' },
  'Promise to Pay': { color: 'green', label: 'Promise to Pay' },
  'Broken Promise': { color: 'red', label: 'Broken Promise' },
  'Call Disconnected RPC': { color: 'green', label: 'Call Disconnected RPC' },
  'Call Disconnected Non RPC': { color: 'green', label: 'Call Disconnected Non RPC' },
  'Not Contacted': { color: 'green', label: 'Not Contacted' },
  'Refused to Pay': { color: 'green', label: 'Refused to Pay' },
  'Requested Call Back': { color: 'green', label: 'Requested Callback' },
  'Third Party Contact': { color: 'green', label: 'ThirdParty Contact' },
  'Message Left': { color: 'green', label: 'Message Left' },
  'Not Contactable': { color: 'red', label: 'Not Contactable' },
  'Ringing no Response': { color: 'red', label: 'Ringing No Response' },
  'Switched Off': { color: 'red', label: 'Switched off' },
  Dispute: { color: 'red', label: 'Dispute' },
  Busy: { color: 'red', label: 'Busy' },
  'Invalid Number': { color: 'red', label: 'Invalid number' },
  'Customer Expired': { color: 'red', label: 'Customer Expired' },
  Others: { color: 'green', label: 'Others' }
} as { [key: string]: CodeMap };

export enum RISK_TAGS {
  DPD30plus_Predict = 'Very high risk',
  DPD15_30_Predict = 'High risk',
  DPD8_14_Predict = 'Medium risk',
  DPD4_7_Predict = 'Low risk',
  DPD1_3_Predict = 'Very low risk'
}

export enum RISK_TAG_COLORS {
  DPD1_3_Predict = '#439FD2',
  DPD4_7_Predict = '#57B71D',
  DPD8_14_Predict = '#FAC509',
  DPD15_30_Predict = '#FFA849',
  DPD30plus_Predict = '#D45058'
}

export const RISK_TAG_SUBSTRING = 'DPD';

export enum FEEDBACK_TYPES {
  PTP = 'PROMISE_TO_PAY',
  REQUESTED_CALLBACK = 'REQUESTED_CALLBACK',
  PTP_UNPAID = 'PTP_UNPAID'
}

export const CURRENT_ALLOCATION_CYCLE = 30;
export const CURRENT_ALLOCATION_CYCLE_FEB = 29;

export const FillColor = [
  {
    max: 100,
    min: 80,
    stroke: 'green',
    color: 'var(--green-base)'
  },
  {
    max: 79,
    min: 60,
    stroke: 'yellow',
    color: 'var(--yellow-base)'
  },
  {
    max: 59,
    min: 40,
    color: 'var(--orange-base)',
    stroke: 'orange'
  },
  {
    max: 39,
    min: 0,
    color: 'var(--navi-color-red-dark)',
    stroke: 'red'
  }
];

export enum LoanCustomerType {
  LOAN_TYPE_FRESH = 'Fresh Loan',
  LOAN_TYPE_TOPUP = 'Top up Loan',
  LOAN_TYPE_REPEAT = 'Repeat Loan'
}
